// extracted by mini-css-extract-plugin
export default {"fileBox":"FileUpload_fileBox__bvsyV","fileName":"FileUpload_fileName__UGikU","labelContainer":"FileUpload_labelContainer__s80tR","fileContainer":"FileUpload_fileContainer__H0U8U"};